import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _attestationInfo = {
    attestationFormSignedDate: 'google.protobuf.Timestamp',
};
var _cbdFlow = { attestationInfo: '_attestationInfo' };
var _getOnboardingAvailabilityRequest = {};
var _getOnboardingAvailabilityResponse = {
    onboardingAvailability: '_onboardingAvailability',
};
var _onboardingAvailability = { cbdFlow: '_cbdFlow' };
var _updateCbdFlowRequest = { cbdFlow: '_cbdFlow' };
var _updateCbdFlowResponse = {
    onboardingAvailability: '_onboardingAvailability',
};
var _updatePartnerFlowRequest = {};
var _updatePartnerFlowResponse = {
    onboardingAvailability: '_onboardingAvailability',
};
var _updateRestrictedGoodsFlowRequest = {};
var _updateRestrictedGoodsFlowResponse = {
    onboardingAvailability: '_onboardingAvailability',
};
function resolveWixCashierOnboardingAvailabilityV1OnboardingAvailabilityServiceUrl(opts) {
    var domainToMappings = {};
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Fetch current state of onboarding availability for meta site. */
export function getOnboardingAvailability(payload) {
    var _a = serializer(_getOnboardingAvailabilityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOnboardingAvailabilityResponse, {
        _attestationInfo: _attestationInfo,
        _cbdFlow: _cbdFlow,
        _onboardingAvailability: _onboardingAvailability,
    }).fromJSON;
    function __getOnboardingAvailability(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            method: 'GET',
            url: resolveWixCashierOnboardingAvailabilityV1OnboardingAvailabilityServiceUrl({ protoPath: '/v1/onboarding-availability', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOnboardingAvailability.fromReq = fromReq;
    return __getOnboardingAvailability;
}
/** Update current state of CBD flow for meta site. */
export function updateCbdFlow(payload) {
    var _a = serializer(_updateCbdFlowRequest, { _attestationInfo: _attestationInfo, _cbdFlow: _cbdFlow }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCbdFlowResponse, {
        _attestationInfo: _attestationInfo,
        _cbdFlow: _cbdFlow,
        _onboardingAvailability: _onboardingAvailability,
    }).fromJSON;
    function __updateCbdFlow(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            method: 'PATCH',
            url: resolveWixCashierOnboardingAvailabilityV1OnboardingAvailabilityServiceUrl({
                protoPath: '/v1/onboarding-availability/cbd-flow',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCbdFlow.fromReq = fromReq;
    return __updateCbdFlow;
}
/** Update current state of Restricted Goods flow for meta site. */
export function updateRestrictedGoodsFlow(payload) {
    var _a = serializer(_updateRestrictedGoodsFlowRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateRestrictedGoodsFlowResponse, {
        _attestationInfo: _attestationInfo,
        _cbdFlow: _cbdFlow,
        _onboardingAvailability: _onboardingAvailability,
    }).fromJSON;
    function __updateRestrictedGoodsFlow(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            method: 'PATCH',
            url: resolveWixCashierOnboardingAvailabilityV1OnboardingAvailabilityServiceUrl({
                protoPath: '/v1/onboarding-availability/restricted-goods-flow',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateRestrictedGoodsFlow.fromReq = fromReq;
    return __updateRestrictedGoodsFlow;
}
/** Update current state of partner flow for meta site. */
export function updatePartnerFlow(payload) {
    var _a = serializer(_updatePartnerFlowRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updatePartnerFlowResponse, {
        _attestationInfo: _attestationInfo,
        _cbdFlow: _cbdFlow,
        _onboardingAvailability: _onboardingAvailability,
    }).fromJSON;
    function __updatePartnerFlow(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            method: 'PATCH',
            url: resolveWixCashierOnboardingAvailabilityV1OnboardingAvailabilityServiceUrl({
                protoPath: '/v1/onboarding-availability/partner-flow',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updatePartnerFlow.fromReq = fromReq;
    return __updatePartnerFlow;
}
//# sourceMappingURL=http.impl.js.map